import { __awaiter } from 'tslib';
import 'long';
import '../../proto/index.js';
import { ErrorType } from '../../core/consts.js';
import '../../core/metrics/logger.js';
import { BaseError } from '../../core/errors/BaseError.js';
import '../../core/metrics/monitor.js';
import '../../core/network/NetworkItem.js';
import '../../core/service/RuntimeContext.js';
import 'json-long';
import 'moize';
import '../../core/model/Message.js';
import 'js-md5';
import '../../core/utils/lz4.js';
import '../../core/utils/serializer.js';
import '../../adapter/manager/AdapterManager.js';
import '../../adapter/manager/types.js';
import '../../core/utils/ticker.js';
import '../../adapter/abstract/IMNetApi.js';
import '../../core/options.js';
import '../../core/utils/uuid.js';
import '../../core/service/ConversationManager.js';
import '../../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../../core/plugin/DbProxy.js';
import '../../core/metrics/trackerTypes.js';
import '../../core/model/CommandMessage.js';
import { decryptAesGcm } from './aesGcm.js';

const AES_256_GCM = 'aes-256-gcm';
const AES_256_GCM_CHUNKS = 'aes-256-gcm-chunks';
const CENC_AES_CTR = 'cenc-aes-ctr';
const supportCipher = [AES_256_GCM];
function getDecryptor(ctx, algorithm) {
    if (!supportCipher.includes(algorithm)) {
        throw new BaseError({
            ctx,
            msg: `not support cipher algorithm: ${algorithm}`,
            sender: this,
            type: ErrorType.MPNotSupportCipher
        });
    }
    switch (algorithm) {
        case AES_256_GCM:
            return decryptAesGcm;
        case AES_256_GCM_CHUNKS:
        case CENC_AES_CTR:
            throw new BaseError({
                ctx,
                msg: `not support: ${algorithm}`,
                sender: this,
                type: ErrorType.MPNotSupportCipher
            });
        default:
            throw new BaseError({
                ctx,
                msg: `not found suitable decrpytor for algorithm: ${algorithm}`,
                sender: this,
                type: ErrorType.MPNotSupportCipher
            });
    }
}
function executeDecryptor(ctx, decryptor, rawData, secretKey) {
    return __awaiter(this, void 0, void 0, function* () {
        let decryptedData;
        const rawKey = new Uint8Array(secretKey.match(/[\da-f]{2}/gi).map(h => parseInt(h, 16)));
        const decrpytorFunc = decryptor(rawData.slice(12), rawKey.buffer, rawData.slice(0, 12));
        if (decrpytorFunc instanceof Promise) {
            decryptedData = yield decrpytorFunc;
        }
        else if (decrpytorFunc instanceof ArrayBuffer) {
            decryptedData = decrpytorFunc;
        }
        else {
            throw new BaseError({
                ctx,
                msg: 'invalid provided decryptor',
                type: ErrorType.MPNotSupportCipher,
                sender: this
            });
        }
        return decryptedData;
    });
}

export { executeDecryptor, getDecryptor };
//# sourceMappingURL=index.js.map
